"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const SSO_LOGIN = 'epicSsoLogin';
class RefreshOnSessionChange extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.loginListener = event => {
            // refresh current page if login Status has been changed
            if (event.key === SSO_LOGIN && event.newValue !== event.oldValue) {
                let loggedInValue = event.newValue;
                // Fix for IE storing values as strings rather than bools
                if (typeof loggedInValue === 'string') {
                    loggedInValue = loggedInValue === 'true';
                }
                // Fix for IE this is always fired immediately upon loading the page so only act on it
                // if the value is not what we expect
                if (this.props.isLoggedIn !== loggedInValue) {
                    setImmediate(window_or_global_1.default.location.reload.bind(window_or_global_1.default.location));
                }
            }
        };
        this.isLocalStorageAvailable = () => {
            let isAvailable = true;
            try {
                window_or_global_1.default.localStorage.setItem('test', 'test');
                window_or_global_1.default.localStorage.removeItem('test');
            }
            catch (e) {
                isAvailable = false;
            }
            return isAvailable;
        };
        this.initLoginFlag = () => {
            const { isLoggedIn } = this.props;
            if (typeof isLoggedIn === 'boolean') {
                window_or_global_1.default.localStorage[SSO_LOGIN] = isLoggedIn;
            }
        };
    }
    componentDidMount() {
        if (typeof window_or_global_1.default.addEventListener === 'function' && this.isLocalStorageAvailable()) {
            this.initLoginFlag();
            window_or_global_1.default.addEventListener('storage', this.loginListener);
        }
    }
    componentWillUnmount() {
        if (typeof window_or_global_1.default.removeEventListener === 'function' && this.isLocalStorageAvailable()) {
            window_or_global_1.default.removeEventListener('storage', this.loginListener);
        }
    }
    render() {
        return this.props.children;
    }
}
RefreshOnSessionChange.propTypes = {
    children: prop_types_1.default.node,
    isLoggedIn: prop_types_1.default.bool.isRequired
};
exports.default = RefreshOnSessionChange;
//# sourceMappingURL=RefreshOnSessionChange.js.map